import React from 'react'

export const locale = {

    curren_user_name:'موقع شوق',
    my_products:'السلع والعروض',
    manage_products_offers:'إدارة السلع والعروض',
    add_new_product:'إضافة السلع',
    orders:'الطلبات',
    manage_orders:'إدارة الطلبات',
    what_to_sell : "ماذا تريد أن تبيع؟",
    search_placeholder: "ابحث من خلال اسم المنتج، او الرقم التسلسلي الخاص به",
    tooltip_search_hint: "ابدأ بإضافة منتجاتك من خلال البحث عنها عن طريق الاسم أو رقم الموديل",
    search:'بحث',
    categories:'التصنيفات',
    product_bulk_upload_heading: 'هل لديك قائمة سلع جاهزة؟',
    product_bulk_upload_desc:'إذا كانت قائمة السلع جاهزة ومعبئة بما يتناسب مع معايير الإدراج، اضغط على زر التحميل',
    product_bulk_upload_desc_2:'إذا كانت قائمة السلع جاهزة لديك يرجى إرسالها لنا عبر البريد الالكتروني:',
    product_bulk_upload_button:'تحميل قائمة السلع',
    load_more_categories:'تحميل المزيد من التصنيفات...',
    sell_this_product:'بيع هذا المنتج',
    required:':field اجباري',
    quantity:'الكمية',
    price:"السعر",
    sku:"رقم تخزين المنتج",
    seller_notes:"ملاحظات البائع",
    handling_time:"المدة المطلوبة لتجهيز المنتج",
    product_condition:"حالة المنتج",
    pcondition:"حالة المنتج",
    specify_your_own: 'غير ذلك؟',
    choose: 'اختر...',
    // product_title_ar: 'عنوان المنتج بالعربية',
    product_title_ar: 'عنوان المنتج',
    // product_description_ar: 'وصف المنتج بالعربية',
    product_description_ar: 'وصف المنتج',
    product_breadcrumb_prefix: 'فئة المنتج:',
    // product_tooltip_title: 'عنوان السلعة بالعربية',
    product_tooltip_title: 'عنوان السلعة',
    // product_tooltip_description_ar: '<div>وصف المنتج بالعربية</div><div class="tooltip__content">ما هي مواصفات وتفاصيل المنتج الذي تود بيعه؟</div>',
    product_tooltip_description_ar: '<div>وصف المنتج</div><div class="tooltip__content">ما هي مواصفات وتفاصيل المنتج الذي تود بيعه؟</div>',
    btn_create_product: 'إضافة المنتج',
    create_product:'إضافة منتج جديد',
    btn_cancel: 'إلغاء',
    btn_next: 'التالي',
    btn_prev: 'السابق',
    sell_the_product: 'بيع المنتج: ',
    sell_product_tooltip_quantity: 'الكمية',
    sell_product_tooltip_price: 'السعر',
    sell_product_tooltip_old_price: '<div>السعر القديم</div><div class="tooltip__content">اتركه فارغا في حال لم يكن للمنتج سعر قديم</div>',
    sell_product_tooltip_sku: 'رقم تخزين المنتج',
    sell_product_tooltip_notes: '<div>ملاحظات البائع</div><div class="tooltip__content">أضف ملاحظاتك الخاصة بهذا المنتج وليس تفاصيل المنتج</div>',
    sell_product_tooltip_handling_time: 'المدة المطلوبة لتجهيز المنتج',
    sell_product_product_condition: 'حالة المنتج من حيث الاستخدام',
    sell_product_tooltip_free_shipping: 'شحن مجاني؟',
    btn_add_product_to_sell: 'إضافة المنتج',
    shipping_delivery_option: 'طريقة تسليم الطلب',
    shipping_to_westbank: 'الشحن إلى الضفة الغربية',
    shipping_to_jerusalem: 'الشحن إلى القدس',
    shipping_to_48_area: 'الشحن إلى مناطق ال48',
    shipping_to_gaza: 'الشحن إلى غزة',
    free_shipping: 'أنا كتاجر أتحمل تكلفة شحن المنتج لمناطق الضفة (ستدفع تكلفة شحن السلعة)',
    free_shipping_jerusalem: 'أنا كتاجر أتحمل تكلفة شحن المنتج لمناطق القدس (ستدفع تكلفة شحن السلعة)',
    free_shipping_gaza: 'أنا كتاجر أتحمل تكلفة شحن المنتج لمناطق غزة (ستدفع تكلفة شحن السلعة)',
    free_shipping_48: 'أنا كتاجر أتحمل تكلفة شحن المنتج لمناطق ال48 (ستدفع تكلفة شحن السلعة)',
    apply_price_to_all:'اعتماد السعر للكل',
    apply_sku_to_all:'اعتماد رقم التخزين للكل',
    copyrights:'جميع الحقوق محفوظة - متجر shooq ©',
    numeric_only:'هذا الحقل يجب ان يكون رقم فقط',
    product_name: 'اسم المنتج',
    status: 'الحالة',
    old_price: 'السعر القديم',
    updated_at: 'آخر تحديث',
    next:'التالي',
    previous:'السابق',
    pickup_from:'عنوان المتجر الذي يوجد فيه السلعة',
    edit_product_breadcrumb_prefix:'تعديل المنتج:',
    product_arabic_title_is_required:'اسم المنتج مطلوب!',
    product_arabic_description_is_required:'وصف المنتج مطلوب!',
    error_page_not_found: 'عذرا، هذه الصفحة غير موجودة أو أنك لا تملك الصلاحيات الكافية لعرضها!',
    btn_update: 'تحديث',
    no_more_products_or_offers: 'عذرا، لا يوجد المزيد من المنتجات أو العروض.',
    product_details: 'معلومات المنتج',
    show_product_details: 'شاهد كافة التفاصيل',
    what_type_of_product: 'ما هو نوع المنتج',
    current_page: 'الصفحة:',
    order_number: 'طلب #',
    fees: 'الرسوم',
    order_sub_total: 'المجموع',
    order_total: 'المجموع الكلي',
    buyer_name: 'اسم المشتري',
    order_date: 'تاريخ الطلب',
    no_orders_found: 'لم يتم العثور على أي طلبات في هذه القائمة!',
    no_products_found: 'لم يتم العثور على منتجات في هذا التصنيف!',
    no_products_found_by_search: 'لم يتم العثور على نتائج البحث!',
    all_categories: 'كل التصنيفات',
    sell_product_added_successfully: 'تم إضافة المنتج إلى قائمة منتجاتك بنجاح!',
    your_product_updated_successfully: 'تم تحديث المنتج بنجاح!',
    changing_order_status: 'جاري تغيير حالة الطلب...',
    order_changed_successfully_to_next_step: 'تم تغيير حالة الطلب إلى المرحلة التالية',
    an_error_occurred_while_changing_order_status: 'حدث خطأ أثناء تغيير حالة الطلب!',
    this_order_in_queue: 'هذا الطلب قيد المعالجة حاليا...',
    did_not_you_found_your_product: 'لم تجد المنتج الذي تبحث عنه ضمن النتائج؟',
    add_new_product_now: 'أضف منتجك الآن',
    add_new_product_now_if_not_exists: 'أضف منتجك الآن إلى الكاتالوج',
    please_fill_the_required_fields: 'يرجى تعبئة الحقول المطلوبة!',
    an_error_occurred_while_creating_your_product: 'حدث خطأ غير متوقع أثناء إضافة منتجك الجديد!',
    an_error_occurred_while_submitting_form: 'حدث خطأ غير متوقع أثناء إرسال البيانات!',
    an_error_occurred_while_check_login: 'حدث خطأ أثناء فحص حالة تسجيل الدخول',
    remove: 'حذف',
    product_images: 'صور المنتج',
    are_you_sure_to_delete_this_item: 'هل أنت متأكد من حذف هذا العنصر؟',
    cannot_upload_this_file: 'لا يمكن تحميل هذا الملف!',
    you_have_canceled_the_file_upload: 'لقد ألغيت رفع الملف!',
    update_sell_product: 'تعديل',
    update_product_props: 'المواصفات',
    product_template_updated_successfully: 'تم تعديل الخصائص بنجاح. وسيتم اعتمادها بعد مراجعتها من الإدارة.',
    you_did_not_change_values_to_update_product: 'لم تقم بتحديث المنتج ليتم تحديثه!',
    you_did_not_change_values_to_create_product: 'لم تقم بإدخال بيانات المنتج حتى الآن!',
    login: 'تسجيل الدخول',
    login_to_your_account: 'تسجيل الدخول إلى حسابك',
    email: 'البريد الالكتروني',
    password: 'كلمة المرور',
    remember_me: 'تذكرني',
    logout: 'تسجيل الخروج',
    logout_success:'تم تسجيل الخروج بنجاح.',
    please_login_to_access: 'ليس لديك الصلاحيات الكافية للوصول إلى هذه الصفحة! يرجى تسجيل الدخول للتمكن من استخدام الموقع!',
    failed_validation_notificant_title: (errorsCount)=>{
        switch (errorsCount){
            case 1:
                return 'تم العثور على حقل واحد مطلوب!';
            case 2:
                return 'ثم العثور على حقلين مطلوبين!';
            default:
                return 'ثم العثور على '+errorsCount+' حقول مطلوبة!';
        }
    },

    get:function(name, placeholders = {}) {
        let occurrence = this[name] ||  name;
        Object.keys(placeholders).forEach(function (key) {
            occurrence = occurrence.replace(new RegExp(':' + key), placeholders[key]);
        });
        return occurrence;
    },

    login_failed:'البريد الالكتروني او كلمة المرور غير صحيحة',
    email_is_required:'البريد الالكتروني اجباري.',
    password_is_required:'كلمة المرور اجبارية.',
    facebook_login_failed:'حدث خطأ ما اثناء عملية الدخول من خلال فيسبوك تاكد من انك قمت بتسجيل الدخول لفيس بوك.',
    email_is_not_valid:'البريد الالكتروني غير صالح.',
    product_images_required:'المنتج بحاجة لصورة واحدة على الاقل.',
    barcode:'الباركود',
    cannot_edit_pending_product :<div> <strong>المنتج بانتظار الموافقة:</strong>  يمكنك تعديل المنتج بعد الموافقة او الرفع على التعديلات المطلوبة</div>,

    mobile_confirm_title:'تفعيل رقم الموبايل',
    mobile_confirm_required_to_sell:'لتستطيع بيع المنتجات من خلال Shooq.com يجب عليك تفعيل حسابك من خلال رقم الموبايل.',
    activation_code : 'رمز التفعيل',
    activate:'تفعيل',
    send_activation : 'ارسال رقم التفعيل',

    mobile_update_title:'اضافة رقم الموبايل',
    mobile_update_required:'رقم الموبايل اجباري لاضافة المنتجات.',
    mobile_number:'رقم الموبايل',
    save:'تخزين',

    mobile_is_required:"يجب ادخال رقم الموبايل",
    mobile_is_invalid:"رقم الموبايل غير صالح",
    mobile_require_activation:"رقم الموبايل بحاجة لتفعيل",
    yes:"نعم",
    no:"لا",
    add_option:"أضف:",
    minimum_characters_to_search: "الحد الأدنى للبحث هو 3 أحرف!",
    at_least_one_variant_required:'يجب ان يتم تفعيل منتج واحد على الاقل ',
    apply_to_all:'تطبيق على الكل',
    apply_images:'نسخ الصور الى...',
    apply_all:'تطبيق للكل',
    shipping:'الشحن',
    relogin_to_your_account:'تسجيل الدخول',
    relogin_to_your_account_hint:'لضمان حماية حسابك، تم تسجيل خروجك تلقائيا من النظام، الرجاء تسجيل الدخول مرة اخرى.',
    relogin_success:'تم تسجيل دخولك بنجاح، يمكنك الان حفظ التغيير التي قمت بإجرائها.',
    buyer_notes:'ملاحظات المشتري',
    you_have_a_note_from_buyer:'لديك ملاحظة من المشتري',
    your_account_requires_email_activation:'الحساب بحاجة للتفعيل عبر البريد الالكتروني',
    resend:'اعادة ارسال كود رابط التفعيل',
    shippping_policy: 'بوليصة الشحن',
    email_or_mobile : 'البريد الالكتروني او رقم الموبايل',
    convert_product_to_package_by_price:"سعر المنتج اقل من 100 شيكل.",
    convert_product_to_package_by_price_desc:"سعر المنتج للقطعة الواحدة اقل من السعر المفضل على موقع شوق، يجب ان يحتوي المنتج على اكثر من قطعة حتى يصل للسعر المفضل.",
    number_of_pieces:"عدد القطع",
    pieces_price_is_little:"سعر القطع يجب ان يكون اكثر من 100 شيكل.",
    ok:"موافق",
    cancel:"الغاء",
    price_per_piece:"سعر القطعة",
    system_currency:"شيكل",
    no_keep_price_as_is:"نعم، ابق السعر كما هو",
    product_bulk_uploading_now:"جاري تحميل السلع",
    business_requirements_update:"بعض المعلومات الخاصة بالمنشأة اجبارية",
    update:"تحديث",
    business_requirements_update_desc:"لكي تتمكن من البدأ بالبيع على الموقع، عليك تعبئة الحقول التالية.",
    business_contact_phone : "رقم هاتف المنشأة",
    hide:'اخفاء',
    select_upload_category:"اختر القسم الخاص بالسلع",
    mapping_upload_fields:"تحديد الاعمدة",
    bulk_upload_invalid_extension:"امتداد الملف المرفوع غير مسموح به.",
    shipper:"الشاحن",
    shipping_by_seller:"الشحن عن طريق البائع (لن يتم ارسال طلبات الشراء الى شركة التوصيل)",
    shipping_method:"طريقة الشحن",
    order_shipping_by_seller:"الشحن عن طريق البائع",
    order_shipping_by_shooq:"الشحن عن طريق متجر shooq",
    order_details:"التفاصيل",
    address:"العنوان",
    mobile:"موبايل",
    total_products:"عدد المنتجات",
    total_ready_orders:":completed من :total_orders",
    show_orders_count:":currentTotal من :total_orders منتج",
    payment_method:"طريقة الدفع",
    shippping_policy_for_all:"بوليصة الشحن للكل",
    email_confirm_title:'البريد الالتكروني بحاجة لتفعيل',
    email_confirm_required_to_sell:'يرجى تفعيل حسابك من خلال البريد الالكتروني :email للإستفادة من خدمات متجر shooq.',
    done:'تم',
    resend_email_activation:'ارسال بريد التفعيل',
    string_max_length_exceeded:'حجم النص يجب ان لا يزيد عن :size',
    views:"المشاهدات",

    update_pieces:"تعديل السعر وعدد القطع",

    no_lists_uploaded:"لم يتم رفع اي قائمة سلع بعد.",
    file_name:"اسم الملف",
    upload_date:"تاريخ الرفع",
    file_type:"نوع الملف",
    completed_products:"المنتجات المكتملة",

    pending_products:"منتجات بانتظار التفعيل",

    product_title:"اسم المنتج",
    product_description:"وصف المنتج",
    product_image:"صورة المنتج",
    product_title_required:"يجب تحديد حقل اسم المنتج ",
    product_price_required:"يجب تحديد حقل سعر المنتج ",
    product_quantity_required:"يجب تحديد حقل كمية المنتج ",

    required_field:"هذا الحقل اجباري.",
    suggested_products:"منتجات مقترحة",

    products_list:"قائمة المنتجات",
    complete:"اكمال",
    select:"تحديد",
    deselect:"الغاء",
    sell:"بيع",
    sold:"تم البيع",
    selling:"جاري البيع",
    add_product:"اضف المنتج",

    download_bulk_samples:"تحميل نماذج المنتجات",
    payment_method_fees:"رسوم طريقة الدفع",
    shipping_fees:"رسوم الشحن",
    sub_total:"المجموع",
    total:"المجموع الكلي",

    financial: 'المالية',
    financial_account_summary: 'ملخص الحساب المالي',
    financial_month_summary: 'ملخص مبيعات الشهر',
    financial_transactions: 'الحركات المالية',
    manage_bank: 'الحساب البنكي',

    select_month: 'اختر الشهر',
    submit: 'إرسال',
    details: 'التفاصيل',
    financial_total_balance: 'الرصيد الكلي',
    financial_month_balance: 'رصيد شهر: <span dir="rtl">:month</span>',
    sold_products: 'المنتجات المباعة',
    withdraw_request: 'اطلب الدفعة',
    you_withdrawal_requests_is_processing: 'قيد المعاجلة',

    my_bank_details: 'بياناتي البنكية',
    beneficiary_name: 'اسم صاحب الحساب',
    bank_name: 'اسم البنك',
    bank_account_number: 'رقم الحساب البنكي',
    bank_branch: 'فرع البنك',
    bank_iban: 'رمز ال IBAN',
    save_details: 'حفظ البيانات',
    iban_is_invalid: 'رمز ال IBAN غير صحيح!',
    please_select_valid_bank: 'يرجى اختيار البنك من القائمة!',
    please_fill_all_required_fields: 'يرجى تعبئة كافة الحقول المطلوبة',

    an_error_occurred_while_initializing_data: 'حدث خطأ أثناء الوصول إلى معلوماتك!',
    your_bank_details_saved_successfully: 'تم حفظ بياناتك البنكية بنجاح',
    an_error_occurred_while_saving_your_bank_details: 'حدث خطأ أثناء محاولة حفظ بياناتك البنكية!',

    what_is_iban: 'ما هو رقم حساب البنك الدولي (IBAN)؟',
    what_is_iban_description: '' +
    '<p>يتكون رقم حساب البنك الدولي من أحرف أبجدية وأرقام وقد تصل عددها إلى 34، وهي كالآتي: أول حرفين كود الدولة حسب معايير الأيزو، بعدها رقمين التحقق، وبعدها رقم حساب البنك الأساسي المخصص للدولة.</p>' +
    '<p>لا يجوز أن يحتوي رقم الحساب البنك الدولي على فراغات اثناء إرساله إلكترونياً. وفي حال كتابته على الورق، فإن رقم الحساب البنكي يعبر عنه في مجموعات من أربعة أحرف مفصولة فيما بينها بفراغ واحد. المجموعة الأخيرة تكون متغيرة الطول كما هو مبين في المثال التالي: </p>' +
    '<p>Country ILXX XXX XXXX XXXX XXXX XXXX XXXX X</p>' +
    '<p>في كتابة رقم الحساب البنكي الدولي يُسمح إستخدام الأرقام من 0- 9 والأحرف الإنجليزية الكبيرة من A -Z. وهذ الأمر يطبق ايضاً في أسماء الدول على سبيل المثال (Saudi Arabia) حيث أن هذه الأحرف لا تستخدم في اللغة العالمية.</p>' +
    '',

    business_name: 'اسم المنشأة',
    payment_way: 'طريقة الدفع',
    credit: 'دائن',
    debit: 'مدين',
    notes: 'ملاحظات',

    month: 'الشهر',
    total_sales: 'اجمالي المبيعات',
    total_sales_shipped_by_seller: 'مبيعات محصلة عن طريق التاجر',
    setup_fees: 'رسوم إعداد',
    lazmak_commission: 'عمولة مبيعات',
    net_sales: 'صافي المبيعات',
    balance: 'الرصيد',
    no_transactions_found: 'لا توجد لديك أية حركات مالية حتى الآن.',
    is_replaced_item: 'مستبدل',
    please_fill_your_bank_details_to_access_to_financial_area: 'يرجى تعبئة بيناتك البنكية لتتمكن من الوصول إلى بياناتك المالية',
    click_here_to_go_to_manage_banks: 'اضغط هنا للانتقال لتعبئة بيناتك البنكية.',
    free_shipping_notification_message: 'عند اختيارك لاحدى الخيارات التالية فإنك كتاجر سوف تتحمل تكاليف الشحن للمنتج بدل المشتري.',

    invoices: 'الفواتير',
    create_invoice: 'إنشاء فاتورة',
    receiver_name: 'اسم المستلم',
    description: 'الوصف',
    new_invoice_row: 'أضف صف جديد',
    invoice_row_is_required: 'يجب إضافة عناصر الفاتورة',
    currency: 'العملة',
    currency_ils: 'شيكل',
    currency_usd: 'دولار',
    is_not_valid:':field غير صحيح',
    view_invoice:'عرض الفاتورة',
    invoice_created_successfully:'تم إنشاء الفاتورة بنجاح.',
    no_invoices_found:'لم يتم العثور على فواتير صادرة من حسابك',
    your_store_account_has_not_been_approved_yet:'حساب متجر (:store_name) قيد المراجعة من قبل إدارة الموقع، ولم تتم الموافقة عليه بعد.',

};